import React from 'react'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { useSelector } from 'react-redux'
import { Col, Container, Row } from 'react-bootstrap'

const Main_Novelties_Jumbotron = (props: RealEstateDataPageComponentData) => {
  const { columns, is_wide, global_data } = props

  const siteId = global_data.id

  const noveltyCard = global_data.content?.cardsNovelties?.type_id ?? '1'
  const { novelties_active } = useSelector(
    (state: { novelties: { tags_active: number[]; novelties_active: Novelty[] } }) =>
      state.novelties,
  )!

  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  const { data: allBlogData, isLoading } = useGetBlogsQuery({ site: siteId })

  return (
    <section className={'grid_novelties a ' + (is_wide ? ' is_wide_component' : '')}>
      <Container fluid>
        <Row className="div_novedades">
          {novelties_active?.length < 0 && (
            <Col
              xs={12}
              className={
                'd-flex flex-wrap justify-content-center w-100 ' + (!is_wide ? 'm-2' : 'p-0')
              }
            >
              <h5 className="text-center mb-5">No hay resultados para esta busqueda</h5>
            </Col>
          )}

          {/* Grid Novelties Col */}
          {/* If columns > 3 the container applies .grid-3-col */}
          {/* Else 2 column grid container */}
          {novelties_active?.length > 0 && (
            <Col
              xs={12}
              className={'justify-content-center w-100' + (!is_wide ? 'm-2' : 'p-0')}
            >
              <Row
                className={
                  (Number(columns) === 2 ? 'gap-3-5 ' : '') +
                  ' grid-novelties-row justify-content-center ' +
                  (columns && Number(columns) === 3
                    ? 'grid-3-col'
                    : Number(columns) === 2
                    ? 'grid-2-col'
                    : 'grid-4-col')
                }
              >
                {isLoading
                  ? [1, 2, 3].map((index) => (
                      <Card
                        key={index}
                        skeleton={true}
                        global_data={global_data}
                      />
                    ))
                  : novelties_active.map((novelty: Novelty, index: number) => (
                      <Card
                        key={index}
                        tags={allBlogData?.tags}
                        novelty={novelty}
                        hidenTags={true}
                        hidenAuthor={true}
                        global_data={global_data}
                      />
                    ))}
              </Row>
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default Main_Novelties_Jumbotron
